/***
 * Summary: here resides the scheme and roles for the fields of the network performing
 * 
 */
import { yupToFormErrors } from "formik";
import * as Yup from "yup";

const TODIS_IIWW_SCHEMA = Yup.object().shape({
  //general section Rules:
  general_road_id: Yup.string("Road ID is alphanumeric"),
  startKm: Yup.number('Value should be number').integer("Number must be integer..").positive('Start KM should be positive..').nullable(true),
  endKm: Yup.number('Value should be number').integer("Number must be integer..").positive('End KM should be positive..').nullable(true),
  dateValidTo: Yup.date("Valid from is a Date").required().nullable(true),
  dateValidFrom: Yup.date("Valid to is a Date").required().nullable(true),
  dateValidFor: Yup.string("Valid for is a Year"),
  tenTCategory: Yup.string("tent category is alphanumeric").nullable(true),
  riverId: Yup.string("river ID is alphanumeric").nullable(true),
  internationalComm: Yup.string("internat Route ID is alphanumeric").nullable(true),
  startNodeName: Yup.string("Start Node Name ID is alphanumeric").nullable(true),
  endNodeName: Yup.string("End Node Name is alphanumeric").nullable(true),
  nameResp: Yup.string("Road ID is alphanumeric").nullable(true),
  addressResp: Yup.string("Road ID is alphanumeric").nullable(true),
  contactPer: Yup.string("Road ID is alphanumeric").nullable(true),
  contactPos: Yup.string("Road ID is alphanumeric").nullable(true),
  contactNum: Yup.string()
    .transform((originalValue) => {
      // Si el valor comienza con '+', eliminamos ese símbolo
      return typeof originalValue === 'string' ? originalValue.replace(/^\+/, '') : originalValue;
    })
    .nullable(true)
    .test('is-valid', 'Invalid data. \'Phone Number\' must be a valid number', function (value) {
      // Permitir números, espacios, y la presencia de '+'
      const isValid = /^[0-9+\s]+$/.test(value) || value === null;

      if (!isValid) {
        throw this.createError({ message: 'Invalid data. \'Phone Number\' must be a valid number' });
      }

      return true;
    }),


  contactEmail: Yup.string("Email")
    .transform((originalValue) => {
      // Realizar transformaciones si es necesario
      return typeof originalValue === 'string' ? originalValue.trim() : originalValue;
    })
    .nullable(true)
    .test('is-email', 'Invalid data. \'Email\' must be valid', function (value) {
      // Si el valor es null, lo consideramos válido y no aplicamos más validaciones
      if (value === null) {
        return true;
      }

      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      const emails = value.split(/[,;:]+/);  // Separar por comas, punto y coma, o dos puntos

      for (const email of emails) {
        if (!emailRegex.test(email.trim())) {
          throw this.createError({ message: `Invalid data. '${email}' must be a valid email address` });
        }
      }

      return true;
    }),

  countryCode: Yup.string("Country Code").nullable(true),
  startKmDirA: Yup.number("Start km Direction A").nullable(true),
  startKmDirB: Yup.number("Start km Direction B").nullable(true),
  endKmDirA: Yup.number("End km Direction A").nullable(true),
  endKmDirB: Yup.number("End km Direction B").nullable(true),
  remarks: Yup.string("remarks").nullable(true),

  iwwImpPmDescDTO: Yup.object().shape({
    projectName: Yup.string('Value should be a text').nullable(true),
    typeForeseenInterven: Yup.string('Value should be a text').nullable(true),
    length: Yup.number('Value should be number').nullable(true),
    totalCostCapex: Yup.number('Value should be number').integer('Value should be an integer').nullable(true),
    remarks: Yup.string("remarks").nullable(true),
  }),
  iwwImpPmEligiTentDTO: Yup.object().shape({
    cemtCalssIvComp: Yup.boolean().nullable(true),
    draught: Yup.boolean().nullable(true),
    bridgeHeight: Yup.boolean().nullable(true),
    risDeployment: Yup.boolean().nullable(true),
    publicationOnWebsite: Yup.boolean().nullable(true),
    lockMaintained: Yup.boolean().nullable(true),
    remarks: Yup.string("remarks").nullable(true),
  }),
  iwwImpPmIndicatorsDTO: Yup.object().shape({
    siAnnTraffDemGro: Yup.number('Value should be number').nullable(true),
    siModalTrans: Yup.number('Value should be number').nullable(true),
    siAnnTraffAcciRateRed: Yup.number('Value should be number').nullable(true),
    eiEirr: Yup.number('Value should be number').nullable(true),
    eiNpv: Yup.number('Value should be number').nullable(true),
    eiSdr: Yup.number('Value should be number').nullable(true),
    eiProjPlanDesCost: Yup.number('Value should be number').nullable(true),
    eiProjConstCost: Yup.number('Value should be number').nullable(true),
    eiTotalProjCost: Yup.number('Value should be number').nullable(true),
    fiFirr: Yup.number('Value should be number').nullable(true),
    fiFnpv: Yup.number('Value should be number').nullable(true),
    fiFdr: Yup.number('Value should be number').nullable(true),
    fiWacc: Yup.number('Value should be number').nullable(true),
    fiFirtsYearProf: Yup.date("Valid to is a Date").nullable(true),
    fiDscr: Yup.number('Value should be number').nullable(true),
    eniCo2Ems: Yup.number('Value should be number').nullable(true),
    eniNoxEms: Yup.number('Value should be number').nullable(true),
    eniSo2Ems: Yup.number('Value should be number').nullable(true),
    eniNmhcEms: Yup.number('Value should be number').nullable(true),
    eniPpm: Yup.number('Value should be number').nullable(true),
    eniNoiseLevel: Yup.number('Value should be number').nullable(true),
    eniCliChangeRes: Yup.number('Value should be number').nullable(true),
    eniProteNatuaAff: Yup.number('Value should be number').nullable(true),
    remarks: Yup.string("remarks").nullable(true)
  }),
  iwwImpPmPiDTO: Yup.object().shape({
    forecastConstPeriod: Yup.number('Value should be number').nullable(true),
    actualConstPeriod: Yup.number('Value should be number').nullable(true),
    forecastCapex: Yup.number('Value should be number').nullable(true),
    actualCapex: Yup.number('Value should be number').nullable(true),
    forecastOpex: Yup.number('Value should be number').nullable(true),
    actualOpex: Yup.number('Value should be number').nullable(true),
    forecastMaintCost: Yup.number('Value should be number').nullable(true),
    actualMaintCost: Yup.number('Value should be number').nullable(true),
    interestDuringConst: Yup.number('Value should be number').nullable(true),
    ebitda: Yup.number('Value should be number').nullable(true),
    forecastRevenue: Yup.number('Value should be number').nullable(true),
    actualRevenue: Yup.number('Value should be number').nullable(true),
    forecastTrainTraffic: Yup.number('Value should be number').nullable(true),
    actualTrainTraffic: Yup.number('Value should be number').nullable(true),
    forecastPassTraffic: Yup.number('Value should be number').nullable(true),
    actualPassTraffic: Yup.number('Value should be number').nullable(true),
    forecastFreightTn: Yup.number('Value should be number').nullable(true),
    actualFreightTn: Yup.number('Value should be number').nullable(true),
    remarks: Yup.string("remarks").nullable(true)
  }),
  iwwImpPmStatusDTO: Yup.object().shape({
    implemented: Yup.string('Value should be a text').nullable(true),
    ongoingProjFs: Yup.string('Value should be a text').nullable(true),
    matureProjFs: Yup.string('Value should be a text').nullable(true),
    projUnderPrep: Yup.string('Value should be a text').nullable(true),
    projStatusDesc: Yup.string('Value should be a text').nullable(true),
    initProjCompDate: Yup.date("Valid to is a Date").nullable(true),
    actualProjCompDate: Yup.date("Valid to is a Date").nullable(true),
    projFundNatBudg: Yup.string('Value should be a text').nullable(true),
    projFundWb: Yup.string('Value should be a text').nullable(true),
    projFundEbrd: Yup.string('Value should be a text').nullable(true),
    projFundEib: Yup.string('Value should be a text').nullable(true),
    otherIfi: Yup.string('Value should be a text').nullable(true),
    otherIfiSpec: Yup.string('Value should be a text').nullable(true),
    concessions: Yup.string('Value should be a text').nullable(true),
    concessionSpec: Yup.string('Value should be a text').nullable(true),
    euFund: Yup.string('Value should be a text').nullable(true),
    euFundSpec: Yup.string('Value should be a text').nullable(true),
    otherFund: Yup.string('Value should be a text').nullable(true),
    otherFundSpec: Yup.string('Value should be a text').nullable(true),
    projDocTitle: Yup.string('Value should be a text').nullable(true),
    projDocPrepBy: Yup.string('Value should be a text').nullable(true),
    projDocSupervBy: Yup.string('Value should be a text').nullable(true),
    remarks: Yup.string("remarks").nullable(true),
  }),
  iwwImpPmTentcompDTO: Yup.object().shape({
    befCemtClassIv: Yup.boolean().nullable(true),
    aftCemtClassIv: Yup.boolean().nullable(true),
    befDrought: Yup.boolean().nullable(true),
    aftDrought: Yup.boolean().nullable(true),
    befBridgeHeight: Yup.boolean().nullable(true),
    aftBridgeHeight: Yup.boolean().nullable(true),
    befRisDeploy: Yup.boolean().nullable(true),
    aftRisDeploy: Yup.boolean().nullable(true),
    befPublicationOnWebsite: Yup.boolean().nullable(true),
    aftPublicationOnWebsite: Yup.boolean().nullable(true),
    befLockMaintained: Yup.boolean().nullable(true),
    aftLockMaintained: Yup.boolean().nullable(true),
    remarks: Yup.string("remarks").nullable(true)
  })
});

const IIWW_INIT = {
  startKm: 0,
  endKm: 0,
  dateValidTo: "",
  dateValidFrom: "",
  dateValidFor: "",
  tentTCategory: "",
  riverId: "",
  internationalComm: "",
  startNodeName: "",
  endNodeName: "",
  nameResp: "",
  addressResp: "",
  contactPer: "",
  contactPos: "",
  contactNum: 0,
  contactEmail: "",
  countryCode: "",
  startKmDirA: 0,
  startKmDirB: 0,
  endKmDirA: 0,
  endKmDirB: 0,
  remarks: "",

  iwwImpPmDescDTO: {
    projectName: "",
    typeForeseenInterven: "",
    length: 0,
    totalCostCapex: 0,
    estiImpDeadline: 0,
    remarks: ""
  },
  iwwImpPmEligiTentDTO: {
    cemtCalssIvComp: false,
    draught: false,
    bridgeHeight: false,
    risDeployment: false,
    publicationOnWebsite: false,
    lockMaintained: false,
    remarks: ""
  },
  iwwImpPmIndicatorsDTO: {
    siAnnTraffDemGro: "",
    siModalTrans: "",
    siAnnTraffAcciRateRed: "",
    eiEirr: "",
    eiNpv: 0,
    eiSdr: "",
    eiProjPlanDesCost: 0,
    eiProjConstCost: 0,
    eiTotalProjCost: 0,
    fiFirr: "",
    fiFnpv: 0,
    fiFdr: "",
    fiWacc: "",
    fiFirtsYearProf: "",
    fiDscr: "",
    eniCo2Ems: "",
    eniNoxEms: "",
    eniSo2Ems: "",
    eniNmhcEms: "",
    eniPpm: "",
    eniNoiseLevel: "",
    eniCliChangeRes: "",
    eniProteNatuaAff: 0,
    remarks: ""
  },
  iwwImpPmPiDTO: {
    forecastConstPeriod: 0,
    actualConstPeriod: 0,
    forecastCapex: 0,
    actualCapex: 0,
    forecastOpex: 0,
    actualOpex: 0,
    forecastMaintCost: 0,
    actualMaintCost: 0,
    interestDuringConst: "",
    ebitda: "",
    forecastRevenue: 0,
    actualRevenue: 0,
    forecastTrainTraffic: "",
    actualTrainTraffic: "",
    forecastPassTraffic: "",
    actualPassTraffic: "",
    forecastFreightTn: "",
    actualFreightTn: "",
    remarks: ""
  },
  iwwImpPmStatusDTO: {
    implemented: "",
    ongoingProjFs: "",
    matureProjFs: "",
    projUnderPrep: "",
    projStatusDesc: "",
    initProjCompDate: "",
    actualProjCompDate: "",
    projFundNatBudg: 1,
    projFundWb: 1,
    projFundEbrd: 1,
    projFundEib: 1,
    otherIfi: 1,
    otherIfiSpec: "",
    concessions: 1,
    concessionSpec: "",
    euFund: 1,
    euFundSpec: "",
    otherFund: 1,
    otherFundSpec: "",
    projDocTitle: "",
    projDocPrepBy: "",
    projDocSupervBy: ""
  },
  iwwImpPmTentcompDTO: {
    befCemtClassIv: false,
    aftCemtClassIv: false,
    befDrought: false,
    aftDrought: false,
    befBridgeHeight: false,
    aftBridgeHeight: false,
    befRisDeploy: false,
    aftRisDeploy: false,
    befPublicationOnWebsite: false,
    aftPublicationOnWebsite: false,
    befLockMaintained: false,
    aftLockMaintained: false,
    remarks: ""
  }
}

export { TODIS_IIWW_SCHEMA, IIWW_INIT };